// extracted by mini-css-extract-plugin
export default {"search":"Search_search__UY4YW","news":"Search_news__g6Zb-","loader":"Search_loader__elYmX","articleContainer":"Search_articleContainer__nP2hd"};